module.exports = __webpack_public_path__ + "video/SAF-400_Ares_SocialEngineering_2025.65626267.vtt";